import "./style.css";
import React, { useContext } from 'react';
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Container, Row, Col } from "react-bootstrap";
import {
  meta,
  section_about,
  section_work,
} from "../../content_option";
import { LanguageContext } from '../../data/language_context';

// Helper function to generate the correct key for section_about lookups
const getLangKey = (selectedLang) => {
  switch (selectedLang) {
    case "Spanish": return "_esp";
    case "Catalan": return "_cat";
    case "English":
    default: return "_eng";
  }
};

export const About = () => {
  const { language: selectedLang } = useContext(LanguageContext);
  const langSuffix = getLangKey(selectedLang); // Determine suffix once

  // Helper function to select text by language from section_about
  const t = (baseKey) => section_about[`${baseKey}${langSuffix}`] || "";

  // Helper function to get timeline data for the current language
  const getTimelineData = (data) => ({
    job_title: data[`jobtitle${langSuffix}`],
    where: data[`where${langSuffix}`],
    date: data[`date${langSuffix}`],
  });

  return (
    <HelmetProvider>
      <Container className="About-header">
        <Helmet>
          <meta charSet="utf-8" />
          <title>{t("main")} | {meta.title}</title>
          <meta name="description" content={meta.description} />
        </Helmet>

        {/* Section Title */}
        <Row className="mb-5 mt-5 pt-md-1">
          <Col lg="8">
            <h1 className="display-4 mb-1">{t("main")}</h1>
            <hr className="t_border my-1 ml-0 text-left" />
          </Col>
        </Row>

        {/* About Me Section */}
        <Row className="sec_sp">
          <Col lg="3">
            <h3 className="color_sec py-2">{t("title1")}</h3>
          </Col>
          <Col lg="12" className="d-flex align-items-center">
            <div><p>{t("content1")}</p></div>
          </Col>
        </Row>

        {/* Work Timeline Section */}
        <Row className="sec_sp">
          <Col lg="3">
            <h3 className="color_sec py-2">{t("title2")}</h3>
          </Col>
          <Col lg="12">
            <table className="table caption-top">
              <thead>
                <tr>
                  <th scope="col">{""}</th>
                  <th scope="col">{t("th_employer")}</th>
                  <th scope="col">{t("th_role")}</th>
                  <th scope="col">{t("th_location")}</th>
                  <th scope="col">{t("th_date")}</th>
                </tr>
              </thead>
              <tbody>
                {section_work.map((data, i) => {
                  const { job_title, where, date } = getTimelineData(data);
                  return (
                    <tr key={i}>
                      <td><img src={data.img} alt={data.employer} style={{ height: "128px", objectFit: "contain" }} /></td>
                      <th scope="row">{data.employer}</th>
                      <td>{job_title}</td>
                      <td>{where}</td>
                      <td>{date}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Col>
        </Row>
      </Container>
    </HelmetProvider>
  );
};